// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell';


const analyticsListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => { 
      console.log(props,">> props >>>")
      return (
      <UserCustomHeader tableProps={props} title='Sku' className='min-w-50px' />
    )},
    id: 'sku',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.sku} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Total Margin' className='min-w-50px' />
    ),
    id: 'Total Margin',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.margin} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Prezzo Vendita' className='min-w-50px' />
    ),
    id: 'prezzoVendita',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.prezzo_vendita } />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Total Amount' className='min-w-50px' />
    ),
    id: 'Total Amount',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.total_amount
      } />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Action' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='IVA' className='min-w-50px' />
  //   ),
  //   id: 'iva',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.iva} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Updated At' className='min-w-50px' />
  //   ),
  //   id: 'updatedAt',
  //   Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index]?.updatedAt).format("YYYY-MM-DD")} />,
  // },
]

export { analyticsListColumns }
